import { useMutation } from '@tanstack/vue-query';

import { invalidateOrderQuery } from '@/entities/order';
import { useBill } from '@/entities/bill';

import { api as pfmApi } from '@/shared/api';

export function useCancelPromocodeMutation(orderId: string, billId: string) {
  const { refetch: refetchBill } = useBill({ orderId });

  return useMutation({
    mutationKey: ['promocodes', 'cancel'],
    mutationFn(promocodeId: string) {
      return pfmApi.client.post('promocodes/cancel', {
        promocode_id: promocodeId,
        bill_id: billId,
      });
    },
    onSuccess() {
      refetchBill();
      invalidateOrderQuery(orderId);
    },
  });
}
